import configSource from "../../res/config.json";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { format } from "date-fns";
import { pdfLayoutsByCountry } from "../../logic/PdfPositions";

export async function GeneratePrivacyNoticePdf(props) {
  const lang = props.params.lang.toLowerCase();
  const today = new Date();
  const dateFormatsByCountry = {
    se: "yyyy-MM-dd",
    no: "yyyy-MM-dd",
    dk: "yyyy-MM-dd",
    uk: "dd-MM-yyyy",
  };
  const date = format(today, dateFormatsByCountry[lang] || "dd-MM-yyyy");

  const fileName = "privacy_notice.pdf";
  const response = await fetch(
    configSource.ROOT + `getimage?company=hcs&country=${lang}&type=${fileName}`,
  );
  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }

  const existingPdfBytes = await response.arrayBuffer();
  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

  const pages = pdfDoc.getPages();
  const firstPage = pages[0];

  const layout = pdfLayoutsByCountry.privacyNotice[lang];

  const capitalizeFirstLetter = (value) => {
    const lowerCased = String(value).toLowerCase();
    return lowerCased.replace(/(^|\s)\S/g, (char) => char.toUpperCase());
  };

  const customerEmail = props.customerInformation.customerEmail;
  const customerName = props.customerInformation.customerName
    ? capitalizeFirstLetter(props.customerInformation.customerName)
    : capitalizeFirstLetter(props.customerInformation.customerFirstName) +
      " " +
      capitalizeFirstLetter(props.customerInformation.customerLastName);
  const dealerName = capitalizeFirstLetter(
    props.customerInformation.dealerName,
  );
  const customerNumber = props.customerInformation.customerNumber;
  const companyNumber = props.customerInformation.companyNumber;

  //Send to:
  firstPage.drawText(customerEmail || "", {
    x: layout.customerEmail.x,
    y: layout.customerEmail.y,
    size: layout.customerEmail.size,
    font: font,
    color: rgb(0, 0, 0),
  });

  firstPage.drawText(`${customerName} (${companyNumber})` || "", {
    x: layout.customerName.x,
    y: layout.customerName.y,
    size: layout.customerName.size,
    font: font,
    color: rgb(0, 0, 0),
  });

  //Date:
  firstPage.drawText(date || "", {
    x: layout.date.x,
    y: layout.date.y,
    size: layout.date.size,
    font: font,
    color: rgb(0, 0, 0),
  });

  //Husqvarna representative:
  firstPage.drawText(`${dealerName} (${customerNumber})` || "", {
    x: layout.dealerName.x,
    y: layout.dealerName.y,
    size: layout.dealerName.size,
    font: font,
    color: rgb(0, 0, 0),
  });

  const pdfBytes = await pdfDoc.save();
  return pdfBytes;
}
